export default __webpack_public_path__ + "static/media/Frame 196.cb13900b.svg";